import { RestSlice } from '../../../../redux/rest.slice';
import { InspectionEvent } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const inspectionsSlice = new RestSlice<InspectionEvent>(
	localizationService.getLocalizedString('screen.labels.inspections'),
	Resource.InspectionEvents
);
export const inspectionsSliceReducer = inspectionsSlice.rests.reducer;
